const API_URL = import.meta.env.VITE_DSA_API_URL || "https://dsa.gazeta.pl";

export const apiPaths = {
  USERINFO: `${API_URL}/api/public/userinfo`,
  REPORT: `${API_URL}/api/public/report`,
  COMPLAINT: `${API_URL}/api/public/complaint`,
} as const;
